import { useMutation } from '@tanstack/react-query';
import { cancelWizardForm } from 'services/product';

export const useCancelPendingFormWizard = (options = {}) => {
  return useMutation({
    mutationFn: cancelWizardForm,
    onSuccess: (data, variables, context) => {
      options.onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      options.onError?.(error, variables, context);
    },
    ...options,
  });
};
